type ApiIssue = { code: string; path: (string | number)[]; message: string };

type ApiError = Error & {
  details?: ApiIssue[];
  detailsRaw?: unknown;
};

const MAX_LISTED_VALUES = 20;

function listValues(values: unknown[]): string {
  const shown = values.slice(0, MAX_LISTED_VALUES).map(String);
  const rest = values.length - shown.length;
  return rest > 0 ? `${shown.join(", ")} (+${rest} more)` : shown.join(", ");
}

function describeIssues(issues: ApiIssue[]): string {
  return issues
    .map(issue => (issue.path.length ? `${issue.path.join(".")}: ${issue.message}` : issue.message))
    .join("; ");
}

function describeRaw(raw: unknown): string | null {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "string") return raw;
  if (Array.isArray(raw)) return listValues(raw);
  if (typeof raw !== "object") return String(raw);
  const parts = Object.entries(raw as Record<string, unknown>).map(([key, value]) =>
    Array.isArray(value)
      ? `${key}: ${listValues(value)}`
      : `${key}: ${typeof value === "object" ? JSON.stringify(value) : String(value)}`,
  );
  return parts.length ? parts.join("; ") : null;
}

export function describeApiError(err: unknown, fallback = "Request failed"): string {
  if (!(err instanceof Error)) return fallback;
  const { message, details, detailsRaw } = err as ApiError;
  const base = message || fallback;
  if (details && details.length > 0) return `${base} — ${describeIssues(details)}`;
  const raw = describeRaw(detailsRaw);
  return raw ? `${base} — ${raw}` : base;
}
